<template>
    <div class="goolist">
        <div class="dialog">
            <el-dialog title="关联商品" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
                <div class="content" v-loading="tabLoad">
                    <div class="form">
                        <el-form ref="form" :model="filter" inline>
                            <el-form-item>
                                <el-input v-model="filter.id" placeholder="请输入商品ID" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input v-model="filter.name" placeholder="请输入商品名称" clearable></el-input>
                            </el-form-item>
                            <el-form-item class="fr">
                                <el-button type="primary" @click="search">查 询</el-button>
                                <el-button type="primary" @click="reset">重 置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="table">
                        <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" v-el-table-infinite-scroll="loadMoreData" ref="multipleTable">
                            <el-table-column align="center" prop="id" label="商品ID"> </el-table-column>
                            <el-table-column align="center" prop="tits" label="商品名称"> </el-table-column>
                            <el-table-column align="center" prop="goods_classifys_relation_str" label="分类">
                                <template slot-scope="scope">
                                    <el-tooltip :content="scope.row.goods_classifys_relation_str | strFmt" placement="top">
                                        <span>
                                            {{ scope.row.goods_classifys_relation_str | strFmt | countFmt }}
                                        </span>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="prices_mains" label="销售价（元）"> </el-table-column>
                            <el-table-column align="center" prop="prices_cbj" label="成本价（元）"> </el-table-column>
                            <el-table-column align="center" prop="prices_defaults" label="市场价（元）"> </el-table-column>
                            <el-table-column align="center" prop="goods_specifications_type_id" label="sku">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.merchandise_inventory == 0">库存不足</div>
                                    <div v-else>
                                        <span v-if="scope.row.goods_specifications_type_id == 1">-</span>
                                        <el-link v-else type="primary" @click="showSpec(scope.row)">
                                            <div>
                                                {{
                                                    scope.row.id_list && scope.row.id_list.length != 0
                                                        ? scope.row.id_list.length == scope.row.spec_list.length
                                                            ? "全选"
                                                            : `已选择${scope.row.id_list.length}个`
                                                        : "选择"
                                                }}
                                            </div>
                                        </el-link>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column type="selection" width="55" :selectable="selectable"> </el-table-column>
                        </el-table>
                        <p v-show="nomore" style="text-align: center; margin-top: 20px; color: #999">暂无更多</p>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="showDetail" type="info" plain>下一步</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            nomore: false,
            tabLoad: false,
            page: 1,
            size: 10,
            dialogVisible: false,
            filter: {
                id: "",
                name: "",
            },
            tableData: [],
            multipleSelection: [],
            Loading: true,
            rowData: null,
            selTableData: [],
            detailData: [],
            isDelete: false,
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                return val.replace(/,/g, ">");
            }
            return "-";
        },
        countFmt(val) {
            if (val) {
                if (val.length >= 8) {
                    return val.substring(0, 8) + "...";
                }
                return val;
            }
            return "-";
        },
    },

    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {},
    created() {
        this.Loading = true;
        this.getList(1);
    },
    methods: {
        ...mapMutations({
            setSelDetailData: "setSelDetailData",
        }),
        ...mapActions({
            goodActivityList: "commodity/goodActivityList",
        }),

        selectable(row, index) {
            if (row.merchandise_inventory == 0) {
                return false;
            } else {
                return true;
            }
        },
        // 点击规格确认时，添加选择规格id
        rowAddList(list) {
            // console.log(this.rowData);
            this.$nextTick(() => {
                this.isDelete = true;
                this.$set(this.rowData, "id_list", list);
                this.selTab();
            });

            this.$forceUpdate();
        },
        // 判断规格是否全选
        selTab() {
            this.$nextTick(() => {
                if (this.rowData.id_list.length == this.rowData.spec_list.length) {
                    this.$refs.multipleTable.toggleRowSelection(this.rowData, true);
                } else {
                    this.$refs.multipleTable.toggleRowSelection(this.rowData, false);
                }
            });
        },
        // 显示选择商品详情
        showDetail() {
            let arr = this.getDetailData();
            let list = [];
            list = arr.map((item) => {
                return item;
            });
            this.multipleSelection.forEach((item) => {
                let f = list.some((o) => {
                    return item.id == o.id;
                });
                if (!f) {
                    list.push(item);
                }
            });
            if (list.length == 0) {
                return this.$message.warning("请先选择商品!");
            }
            this.dialogVisible = false;
            this.$emit("showDetail", list);
        },
        // 显示规格弹框
        showSpec(row) {
            this.rowData = row;
            this.$emit("showSpec", row);
        },
        // 重置
        reset() {
            this.tableData = [];
            this.filter = {
                id: "",
                name: "",
            };
            this.Loading = true;
            this.page = 1;
            this.getList();
        },
        // 搜索
        search() {
            this.tableData = [];
            this.Loading = true;
            this.page = 1;
            this.getList();
        },
        // 滚动表格获取数据
        async loadMoreData() {
            this.Loading = false;
            if (this.size * this.page >= this.total) {
                this.nomore = true;
            } else if (this.size * this.page < this.total) {
                this.page += 1;
                await this.getList();
                this.nomore = false;
            }
        },
        // 选择行
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.toggleAllSelection();
            }
        },
        // 改变选择列表行
        handleSelectionChange(val) {
            this.detailData = [];
            // 上次选择的数据----本次选择的数据
            this.selTableData = this.multipleSelection;
            if (val && val.length > 0) {
                val.forEach((v) => {
                    v.id_list = [];
                    if (v.spec_list && v.spec_list.length > 0) {
                        v.spec_list.forEach((o) => {
                            let obj = {
                                id: o.id,
                                title: o.title,
                                merchandise_inventory: o.merchandise_inventory,
                            };
                            v.id_list.push(obj);
                        });
                    }
                });
            }
            this.multipleSelection = val;
            // 取消选择时，删除所有选择规格

            if (!this.isDelete) {
                if (this.selTableData.length > this.multipleSelection.length) {
                    this.selTableData.forEach((item) => {
                        let f = this.multipleSelection.some((v) => {
                            return item.id == v.id;
                        });
                        if (!f) {
                            this.tableData.forEach((o, i) => {
                                if (o.id == item.id) {
                                    o.id_list = [];
                                }
                            });
                        }
                    });
                }
            }
            this.isDelete = false;
            // 添加选中的数据
            if (this.multipleSelection.length > 0) {
                this.multipleSelection.forEach((item) => {
                    this.detailData.push(item);
                });
            }
        },
        // 获取列表中选择规格的数据
        getDetailData() {
            let arr = [];
            if (this.tableData && this.tableData.length > 0) {
                this.tableData.forEach((item) => {
                    if (item.id_list && item.id_list.length > 0) {
                        arr.push(item);
                    }
                });
            }
            return arr;
        },
        // 去重
        unique(arr) {
            return Array.from(new Set(arr));
        },
        // 获取列表数据
        getList(tag) {
            if (this.Loading) {
                this.tabLoad = true;
            }
            let opt = {
                token: this.getToken,
                id: this.filter.id, //商品id搜索
                tits: this.filter.name, //商品名称搜索
                page: tag == 1 ? 1 : this.page, //当前页数
                size: this.size, //每页显示多少条
            };
            this.goodActivityList(opt).then((res) => {
                this.tabLoad = false;
                this.Loading = false;
                if (res.code == 1) {
                    if (res.data.list && res.data.list.length > 0) {
                        res.data.list.forEach((item) => {
                            this.tableData.push(item);
                        });
                    }
                    this.total = res.data.count ? res.data.count : 0;
                } else{
                    this.$message.error(res.msg)
                }
            });
        },
        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.goolist {
    .content {
        ::v-deep .el-table__body-wrapper {
            height: 400px !important;
        }
    }
    ::v-deep .el-table__body-wrapper {
        border-bottom: none;
    }
    ::v-deep .el-table::before {
        display: none;
    }
}
.fr {
    float: right;
}
.el-pagination {
    text-align: right;
    margin-top: 20px;
}
</style>